var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mode === 'view')?_c('span',{staticClass:"badge badge-warning"},[_vm._v(_vm._s(_vm.label))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }